import { render } from "./FooterView.vue?vue&type=template&id=6c849d2b&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=6c849d2b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c849d2b"]])

export default __exports__